import { useTheme } from "@mui/material/styles";
import React from "react";
export function useVisuallyOpen(open, exitTransitionDuration) {
    const [visuallyOpen, setVisuallyOpen] = React.useState(open);
    const theme = useTheme();
    const timerRef = React.useRef(null);
    React.useEffect(() => {
        if (timerRef.current !== null) {
            window.clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        if (open) {
            setVisuallyOpen(true);
        }
        else if (visuallyOpen) {
            timerRef.current = window.setTimeout(() => {
                setVisuallyOpen(false);
            }, exitTransitionDuration !== null && exitTransitionDuration !== void 0 ? exitTransitionDuration : theme.transitions.duration.leavingScreen);
        }
    }, [open]);
    return visuallyOpen;
}
